import { render, staticRenderFns } from "./scopeManagementAction.vue?vue&type=template&id=9b9b53c2&scoped=true"
import script from "./scopeManagementAction.vue?vue&type=script&lang=js"
export * from "./scopeManagementAction.vue?vue&type=script&lang=js"
import style0 from "./scopeManagementAction.vue?vue&type=style&index=0&id=9b9b53c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9b53c2",
  null
  
)

export default component.exports